import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/hooks';

// AUTH-004: Bereits vorhandene, lokal gespeicherte Sitzung gilt auch
// offline als angemeldet (kein erzwungener Serverkontakt für den Zugriff
// auf lokal verfügbare Daten).
export function ProtectedRoute() {
  const { accessToken, refreshToken } = useAuth();
  if (!accessToken && !refreshToken) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function AdminRoute() {
  const { user } = useAuth();
  if (!user?.isSystemAdmin) return <Navigate to="/lists" replace />;
  return <Outlet />;
}
